module.exports = __webpack_public_path__ + "img/solution7.df0d50d2.jpg";